export const digitMapping = {
	"adlm": [
		"𞥐",
		"𞥑",
		"𞥒",
		"𞥓",
		"𞥔",
		"𞥕",
		"𞥖",
		"𞥗",
		"𞥘",
		"𞥙"
	],
	"ahom": [
		"𑜰",
		"𑜱",
		"𑜲",
		"𑜳",
		"𑜴",
		"𑜵",
		"𑜶",
		"𑜷",
		"𑜸",
		"𑜹"
	],
	"arab": [
		"٠",
		"١",
		"٢",
		"٣",
		"٤",
		"٥",
		"٦",
		"٧",
		"٨",
		"٩"
	],
	"arabext": [
		"۰",
		"۱",
		"۲",
		"۳",
		"۴",
		"۵",
		"۶",
		"۷",
		"۸",
		"۹"
	],
	"bali": [
		"᭐",
		"᭑",
		"᭒",
		"᭓",
		"᭔",
		"᭕",
		"᭖",
		"᭗",
		"᭘",
		"᭙"
	],
	"beng": [
		"০",
		"১",
		"২",
		"৩",
		"৪",
		"৫",
		"৬",
		"৭",
		"৮",
		"৯"
	],
	"bhks": [
		"𑱐",
		"𑱑",
		"𑱒",
		"𑱓",
		"𑱔",
		"𑱕",
		"𑱖",
		"𑱗",
		"𑱘",
		"𑱙"
	],
	"brah": [
		"𑁦",
		"𑁧",
		"𑁨",
		"𑁩",
		"𑁪",
		"𑁫",
		"𑁬",
		"𑁭",
		"𑁮",
		"𑁯"
	],
	"cakm": [
		"𑄶",
		"𑄷",
		"𑄸",
		"𑄹",
		"𑄺",
		"𑄻",
		"𑄼",
		"𑄽",
		"𑄾",
		"𑄿"
	],
	"cham": [
		"꩐",
		"꩑",
		"꩒",
		"꩓",
		"꩔",
		"꩕",
		"꩖",
		"꩗",
		"꩘",
		"꩙"
	],
	"deva": [
		"०",
		"१",
		"२",
		"३",
		"४",
		"५",
		"६",
		"७",
		"८",
		"९"
	],
	"diak": [
		"𑥐",
		"𑥑",
		"𑥒",
		"𑥓",
		"𑥔",
		"𑥕",
		"𑥖",
		"𑥗",
		"𑥘",
		"𑥙"
	],
	"fullwide": [
		"０",
		"１",
		"２",
		"３",
		"４",
		"５",
		"６",
		"７",
		"８",
		"９"
	],
	"gong": [
		"𑶠",
		"𑶡",
		"𑶢",
		"𑶣",
		"𑶤",
		"𑶥",
		"𑶦",
		"𑶧",
		"𑶨",
		"𑶩"
	],
	"gonm": [
		"𑵐",
		"𑵑",
		"𑵒",
		"𑵓",
		"𑵔",
		"𑵕",
		"𑵖",
		"𑵗",
		"𑵘",
		"𑵙"
	],
	"gujr": [
		"૦",
		"૧",
		"૨",
		"૩",
		"૪",
		"૫",
		"૬",
		"૭",
		"૮",
		"૯"
	],
	"guru": [
		"੦",
		"੧",
		"੨",
		"੩",
		"੪",
		"੫",
		"੬",
		"੭",
		"੮",
		"੯"
	],
	"hanidec": [
		"〇",
		"一",
		"二",
		"三",
		"四",
		"五",
		"六",
		"七",
		"八",
		"九"
	],
	"hmng": [
		"𖭐",
		"𖭑",
		"𖭒",
		"𖭓",
		"𖭔",
		"𖭕",
		"𖭖",
		"𖭗",
		"𖭘",
		"𖭙"
	],
	"hmnp": [
		"𞅀",
		"𞅁",
		"𞅂",
		"𞅃",
		"𞅄",
		"𞅅",
		"𞅆",
		"𞅇",
		"𞅈",
		"𞅉"
	],
	"java": [
		"꧐",
		"꧑",
		"꧒",
		"꧓",
		"꧔",
		"꧕",
		"꧖",
		"꧗",
		"꧘",
		"꧙"
	],
	"kali": [
		"꤀",
		"꤁",
		"꤂",
		"꤃",
		"꤄",
		"꤅",
		"꤆",
		"꤇",
		"꤈",
		"꤉"
	],
	"khmr": [
		"០",
		"១",
		"២",
		"៣",
		"៤",
		"៥",
		"៦",
		"៧",
		"៨",
		"៩"
	],
	"knda": [
		"೦",
		"೧",
		"೨",
		"೩",
		"೪",
		"೫",
		"೬",
		"೭",
		"೮",
		"೯"
	],
	"lana": [
		"᪀",
		"᪁",
		"᪂",
		"᪃",
		"᪄",
		"᪅",
		"᪆",
		"᪇",
		"᪈",
		"᪉"
	],
	"lanatham": [
		"᪐",
		"᪑",
		"᪒",
		"᪓",
		"᪔",
		"᪕",
		"᪖",
		"᪗",
		"᪘",
		"᪙"
	],
	"laoo": [
		"໐",
		"໑",
		"໒",
		"໓",
		"໔",
		"໕",
		"໖",
		"໗",
		"໘",
		"໙"
	],
	"lepc": [
		"᪐",
		"᪑",
		"᪒",
		"᪓",
		"᪔",
		"᪕",
		"᪖",
		"᪗",
		"᪘",
		"᪙"
	],
	"limb": [
		"᥆",
		"᥇",
		"᥈",
		"᥉",
		"᥊",
		"᥋",
		"᥌",
		"᥍",
		"᥎",
		"᥏"
	],
	"mathbold": [
		"𝟎",
		"𝟏",
		"𝟐",
		"𝟑",
		"𝟒",
		"𝟓",
		"𝟔",
		"𝟕",
		"𝟖",
		"𝟗"
	],
	"mathdbl": [
		"𝟘",
		"𝟙",
		"𝟚",
		"𝟛",
		"𝟜",
		"𝟝",
		"𝟞",
		"𝟟",
		"𝟠",
		"𝟡"
	],
	"mathmono": [
		"𝟶",
		"𝟷",
		"𝟸",
		"𝟹",
		"𝟺",
		"𝟻",
		"𝟼",
		"𝟽",
		"𝟾",
		"𝟿"
	],
	"mathsanb": [
		"𝟬",
		"𝟭",
		"𝟮",
		"𝟯",
		"𝟰",
		"𝟱",
		"𝟲",
		"𝟳",
		"𝟴",
		"𝟵"
	],
	"mathsans": [
		"𝟢",
		"𝟣",
		"𝟤",
		"𝟥",
		"𝟦",
		"𝟧",
		"𝟨",
		"𝟩",
		"𝟪",
		"𝟫"
	],
	"mlym": [
		"൦",
		"൧",
		"൨",
		"൩",
		"൪",
		"൫",
		"൬",
		"൭",
		"൮",
		"൯"
	],
	"modi": [
		"𑙐",
		"𑙑",
		"𑙒",
		"𑙓",
		"𑙔",
		"𑙕",
		"𑙖",
		"𑙗",
		"𑙘",
		"𑙙"
	],
	"mong": [
		"᠐",
		"᠑",
		"᠒",
		"᠓",
		"᠔",
		"᠕",
		"᠖",
		"᠗",
		"᠘",
		"᠙"
	],
	"mroo": [
		"𖩠",
		"𖩡",
		"𖩢",
		"𖩣",
		"𖩤",
		"𖩥",
		"𖩦",
		"𖩧",
		"𖩨",
		"𖩩"
	],
	"mtei": [
		"꯰",
		"꯱",
		"꯲",
		"꯳",
		"꯴",
		"꯵",
		"꯶",
		"꯷",
		"꯸",
		"꯹"
	],
	"mymr": [
		"၀",
		"၁",
		"၂",
		"၃",
		"၄",
		"၅",
		"၆",
		"၇",
		"၈",
		"၉"
	],
	"mymrshan": [
		"႐",
		"႑",
		"႒",
		"႓",
		"႔",
		"႕",
		"႖",
		"႗",
		"႘",
		"႙"
	],
	"mymrtlng": [
		"꧰",
		"꧱",
		"꧲",
		"꧳",
		"꧴",
		"꧵",
		"꧶",
		"꧷",
		"꧸",
		"꧹"
	],
	"newa": [
		"𑑐",
		"𑑑",
		"𑑒",
		"𑑓",
		"𑑔",
		"𑑕",
		"𑑖",
		"𑑗",
		"𑑘",
		"𑑙"
	],
	"nkoo": [
		"߀",
		"߁",
		"߂",
		"߃",
		"߄",
		"߅",
		"߆",
		"߇",
		"߈",
		"߉"
	],
	"olck": [
		"᱐",
		"᱑",
		"᱒",
		"᱓",
		"᱔",
		"᱕",
		"᱖",
		"᱗",
		"᱘",
		"᱙"
	],
	"orya": [
		"୦",
		"୧",
		"୨",
		"୩",
		"୪",
		"୫",
		"୬",
		"୭",
		"୮",
		"୯"
	],
	"osma": [
		"𐒠",
		"𐒡",
		"𐒢",
		"𐒣",
		"𐒤",
		"𐒥",
		"𐒦",
		"𐒧",
		"𐒨",
		"𐒩"
	],
	"rohg": [
		"𐴰",
		"𐴱",
		"𐴲",
		"𐴳",
		"𐴴",
		"𐴵",
		"𐴶",
		"𐴷",
		"𐴸",
		"𐴹"
	],
	"saur": [
		"꣐",
		"꣑",
		"꣒",
		"꣓",
		"꣔",
		"꣕",
		"꣖",
		"꣗",
		"꣘",
		"꣙"
	],
	"segment": [
		"🯰",
		"🯱",
		"🯲",
		"🯳",
		"🯴",
		"🯵",
		"🯶",
		"🯷",
		"🯸",
		"🯹"
	],
	"shrd": [
		"𑇐",
		"𑇑",
		"𑇒",
		"𑇓",
		"𑇔",
		"𑇕",
		"𑇖",
		"𑇗",
		"𑇘",
		"𑇙"
	],
	"sind": [
		"𑋰",
		"𑋱",
		"𑋲",
		"𑋳",
		"𑋴",
		"𑋵",
		"𑋶",
		"𑋷",
		"𑋸",
		"𑋹"
	],
	"sinh": [
		"෦",
		"෧",
		"෨",
		"෩",
		"෪",
		"෫",
		"෬",
		"෭",
		"෮",
		"෯"
	],
	"sora": [
		"𑃰",
		"𑃱",
		"𑃲",
		"𑃳",
		"𑃴",
		"𑃵",
		"𑃶",
		"𑃷",
		"𑃸",
		"𑃹"
	],
	"sund": [
		"᮰",
		"᮱",
		"᮲",
		"᮳",
		"᮴",
		"᮵",
		"᮶",
		"᮷",
		"᮸",
		"᮹"
	],
	"takr": [
		"𑛀",
		"𑛁",
		"𑛂",
		"𑛃",
		"𑛄",
		"𑛅",
		"𑛆",
		"𑛇",
		"𑛈",
		"𑛉"
	],
	"talu": [
		"᧐",
		"᧑",
		"᧒",
		"᧓",
		"᧔",
		"᧕",
		"᧖",
		"᧗",
		"᧘",
		"᧙"
	],
	"tamldec": [
		"௦",
		"௧",
		"௨",
		"௩",
		"௪",
		"௫",
		"௬",
		"௭",
		"௮",
		"௯"
	],
	"telu": [
		"౦",
		"౧",
		"౨",
		"౩",
		"౪",
		"౫",
		"౬",
		"౭",
		"౮",
		"౯"
	],
	"thai": [
		"๐",
		"๑",
		"๒",
		"๓",
		"๔",
		"๕",
		"๖",
		"๗",
		"๘",
		"๙"
	],
	"tibt": [
		"༠",
		"༡",
		"༢",
		"༣",
		"༤",
		"༥",
		"༦",
		"༧",
		"༨",
		"༩"
	],
	"tirh": [
		"𑓐",
		"𑓑",
		"𑓒",
		"𑓓",
		"𑓔",
		"𑓕",
		"𑓖",
		"𑓗",
		"𑓘",
		"𑓙"
	],
	"vaii": [
		"ᘠ",
		"ᘡ",
		"ᘢ",
		"ᘣ",
		"ᘤ",
		"ᘥ",
		"ᘦ",
		"ᘧ",
		"ᘨ",
		"ᘩ"
	],
	"wara": [
		"𑣠",
		"𑣡",
		"𑣢",
		"𑣣",
		"𑣤",
		"𑣥",
		"𑣦",
		"𑣧",
		"𑣨",
		"𑣩"
	],
	"wcho": [
		"𞋰",
		"𞋱",
		"𞋲",
		"𞋳",
		"𞋴",
		"𞋵",
		"𞋶",
		"𞋷",
		"𞋸",
		"𞋹"
	]
};
